import React, { Component } from 'react';
import './GiftBar.scss';

class GiftBar extends Component {
  calcNumberOfRedGifts() {
    let percentage = this.props.countFulfilledWishes / this.props.countWishes;
    let amount = this.props.numberOfGifts * percentage;
    return Math.floor(amount);
  }

  render() {
    let gifts = [];
    let redGifts = this.calcNumberOfRedGifts();
    let iconSize = this.props.numberOfGifts > 5 ? 'fa-3x' : 'fa-2x';

    for (let i = 0; i < this.props.numberOfGifts; i++) {
      let color = '#DDDDDD';
      if (i < redGifts) {
        color = '#B6102F';
      }
      gifts.push(
        <i
          className={
            'fas fa-gift ' +
            iconSize +
            ' animated fadeInUp animation_delay_' +
            i
          }
          key={i}
          style={{ color: color }}
        />
      );
    }

    return (
      <div className="row">
        <div className="col-lg-8 col-lg-offset-2 col-md-10 col-md-offset-1 gift-bar">
          <div className="media">
            <div className="media-left col-md-3 media-middle">
              <h4 className="wish-info">
                <strong>{this.props.countWishes} Geschenke</strong>
              </h4>
              <h4 className="wish-info">
                <strong>{this.props.countFulfilledWishes} erfüllt</strong>
              </h4>
            </div>
            <div className="media-body text-left">
              <div
                style={{
                  width: '100%',
                  height: '100%',
                  display: 'flex',
                  justifyContent: 'space-around',
                  alignItems: 'center'
                }}
              >
                {gifts}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default GiftBar;



// WEBPACK FOOTER //
// ./src/Component/GiftBar.js